// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo } from "react";

import React from "react";
function RelativeLoader() {
  return (
    <>
      <div className="bg-[#fff] z-50 relative top-0 left-0 right-0 bottom-0 flex items-center justify-center ">
        <div className="px-4  py-bg-white m-auto">
          <div className="mx-auto flex justify-center">
            <div className="relative">
              <img
                className="w-20 h-20"
                alt="loading..."
                src={
                  "https://hwlobbystorer1.blob.core.windows.net/gifloaders/loader-gif-256px.gif"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(RelativeLoader);
